module.exports = __webpack_public_path__ + "img/amtl-deluxe.c9b3cf27.png";